export enum PermissibleDeductionConfig {
  Limited,
  Unlimited
}
